import { createSelector } from 'reselect';
import { RootState } from '../..';


export const getModals = (state: RootState) => state.modals;

export const getOpenModals = createSelector(
  getModals,
  (modals) => modals.openModals,
);

export const isModalOpen = createSelector<RootState, string, string[], string, boolean>(
  getOpenModals,
  (_, modalName) => modalName,
  (openModals, modalName) => !!openModals.find((openModalName) => openModalName === modalName),
);

export const getStackOrder = createSelector<RootState, string, string[], string, number>(
  getOpenModals,
  (_, modalName) => modalName,
  (openModals, modalName) => openModals.findIndex((openModalName) => openModalName === modalName),
);
